import type { ComponentType } from 'react'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconCall from '@/shared/icons/NewDesign/IconCall'
import IconHandshake from '@/shared/icons/NewDesign/IconHandshake'
import IconSell from '@/shared/icons/NewDesign/IconSell'
import IconRouter from '@/shared/icons/NewDesign/IconRouter'
import IconShieldPlus from '@/shared/icons/NewDesign/IconShieldPlus'
import IconStorefront from '@/shared/icons/NewDesign/IconStorefront'
import IconTrendingUp from '@/shared/icons/NewDesign/IconTrendingUp'
import IconCarbonWater from '@/shared/icons/IconCarbonWater'
import type { SDIconProps } from '@/shared/icons/SDIcon'

export const POLE_ICONS: Record<string, ComponentType<SDIconProps>> = {
  inbound_energy: IconBolt,
  inbound_telecom: IconRouter,
  inbound_insurance: IconShieldPlus,
  white_label: IconStorefront,
  business_developer: IconHandshake,
  performance: IconTrendingUp,
  water: IconCarbonWater,
  outbound: IconCall,
  other_sales: IconSell,
}
